import { store } from '@core/Store'
import { determineUserRegulationId } from '@core/Areas/KambiClient/helpers/regulation'
import {
  tryToLoginKambiPlayer,
  tryToLogoutKambiPlayer,
} from '@core/Areas/KambiClient/helpers/authentication'
import { createLogger } from '@core/Areas/KambiClient/helpers/logging'
import { ResidentialDetail } from '@core/State/UserAccount/userAccountDriver'
import { List } from 'typings/immutable'
import { setIsKambiLoginPending } from '../Store'
import { selectIsLoggedIn, selectLoginPending, selectLogoutToken } from '../Store/selectors'

const syncLog = createLogger('orange', 'KAMBI: Sync user login status')

// Handle LOGIN
export async function handleKambiLogin(
  accountNumber: number,
  residentialDetail: List<ResidentialDetail>
): Promise<void> {
  const isKambiLoggedIn = selectIsLoggedIn(store.getState())
  if (isKambiLoggedIn) return

  const isKambiLoginPending = selectLoginPending(store.getState())
  if (isKambiLoginPending) {
    syncLog('login pending')
    return
  }

  store.dispatch(setIsKambiLoginPending(true))

  try {
    syncLog('user logged in, trying to log kambi in')

    const regulationId = determineUserRegulationId(residentialDetail)
    await tryToLoginKambiPlayer(accountNumber, regulationId)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('ERROR: Kambi Login', error)
  } finally {
    store.dispatch(setIsKambiLoginPending(false))
  }
}

// Handle LOGOUT
export async function handleKambiLogout(): Promise<void> {
  const isKambiLoggedIn = selectIsLoggedIn(store.getState())
  const logoutToken = selectLogoutToken(store.getState())

  if (!(isKambiLoggedIn && logoutToken)) return

  try {
    syncLog('user logged out, trying to log kambi out')

    await tryToLogoutKambiPlayer(logoutToken)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('ERROR: Kambi Logout', error)
  }
}
